// extracted by mini-css-extract-plugin
module.exports = {"root":"_fa9ded1","name":"_a8a3837","button":"_de9cc71","disabled":"_e1faf14"};